import styled from 'styled-components';
import Icon from '../Icon';
import Typography from '../Typography';

export const IconWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const DropdownMenuItemContent = styled(Typography)<{ isDisabled: boolean }>`
    align-items: center;
    cursor: pointer;
    display: grid;
    grid-template-columns: auto 1fr;
    text-decoration: none;
    text-decoration: initial;
    padding: 6px 12px;

    div {
        color: ${props => props.isDisabled && props.theme.root.colors.basicColors['25%']};
    }

    ${Icon} {
        margin-right: 8px;

        svg {
            path {
                fill: ${props =>
                    props.isDisabled
                        ? props.theme.root.colors.basicColors['25%']
                        : props.theme.root.colors.basicColors['55%']};
                fill-opacity: 1;
            }
        }
    }
`;

export const DropdownMenuItemContainer = styled.li<{ isDisabled: boolean }>`
    &:hover {
        background: ${props => props.theme.root.colors.basicColors['4%']};
    }

    &:first-of-type {
        padding: 0;
    }
    &:first-of-type:hover {
        background: ${props => props.theme.root.colors.basicColors['4%']};
    }

    &:last-of-type {
        padding-right: 0;
    }

    ${props => props.isDisabled && 'pointer-events: none'};
    ${props => props.isDisabled && 'cursor: not-allowed'};
`;

export const TruncatedLabel = styled.span`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;
